import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserManagementService } from '../user-management/user-management.service';
import { Router, NavigationEnd } from '@angular/router';
import { NotificationsService } from '../notifications/notifications.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-corporate-admin-nav',
    templateUrl: './corporate-admin-nav.component.html',
    styleUrls: ['./corporate-admin-nav.component.css'],
    standalone: false
})
export class CorporateAdminNavComponent implements OnInit, OnDestroy {
  @ViewChild('notificationListComponent') notificationListComponent: any;
  
  public isCollapsed = false;
  public isMenuCollapsed = true;
  sitename: string;
  userRole: any;
  userDetail: any;
  isNavigating: boolean = false;
  activeCategory: any;
  
  // Notification properties
  unreadNotificationCount = 0;
  isNotificationPanelOpen = false;
  private subscriptions: Subscription[] = [];
  
  constructor(
    private userService: UserManagementService,
    private router: Router,
    private notificationService: NotificationsService,
    private cdr: ChangeDetectorRef
  ) {
    this.userDetail = this.userService.getUserDetail();
    this.userRole = this.userDetail.role;
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.getSiteName();
      }
    });
    
    // Subscribe to notification unread count
    const unreadSub = this.notificationService.unreadCount$.subscribe(
      (count) => {
        this.unreadNotificationCount = count;
        // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        this.cdr.detectChanges();
      }
    );
    this.subscriptions.push(unreadSub);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  logout() {
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
  }

  getSiteName() {
    this.sitename = this.userService.getCurrentSitename();
  }

  setSiteName() {
    this.userService.setCurrentSitename('');
  }

  navigateToType(type: any) {
    if (this.isNavigating) return;
  
    this.isNavigating = true; 
    this.router.navigate(['/mixdashboard/mix-report-list', type])
      .finally(() => {
        this.isNavigating = false; 
      });
  }
  navigateToList(type: any) {
    //if (this.isNavigating) return;
   //this.isNavigating = true; 
    this.router.navigate(['/mixdashboard/mix-report-list', 0],{ queryParams: { type: type }}
      )
      .finally(() => {
         window.location.reload();
      });
      ;
  }
  
  // Notification Panel Methods
  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
    // Prevent body scroll when panel is open
    if (this.isNotificationPanelOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen = false;
    document.body.style.overflow = '';
  }

  onBackdropClick(event: MouseEvent): void {
    // Close panel when clicking on backdrop
    if ((event.target as HTMLElement).classList.contains('notification-backdrop')) {
      this.closeNotificationPanel();
    }
  }
}